module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.d815b0a2.otf";